import { render, staticRenderFns } from "./UbahKategori.vue?vue&type=template&id=391dd22d&scoped=true"
import script from "./UbahKategori.vue?vue&type=script&lang=js"
export * from "./UbahKategori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391dd22d",
  null
  
)

export default component.exports